import {
    getCurrentKey,
    goLogin,
    handlePay,
    toOrder,
    toTrial,
    toRecordInfo,
    parseButtonStatus,
    useButtonStatus
} from '../utils'
import {generateAppMarketInitialState, getAppList, getEnterpriseLoginUrl, getReserveInfo, reserve} from '../api'
import {useDispatch} from '../hooks/useReduxStore'
import {
    selectPayModal,
    setPayModalProductUrl,
    setPayModalCurrentProduct,
    setPayModalAppId,
    setRecordModalInitialState
} from '../store'
import {useSelect} from '../hooks/useSelect'
import {ENTERPRISE_BASE_URL} from "../constants";

const {useEffect, useState, useTransition, useLayoutEffect} = React
const {Button} = antd

// billed_type: 0 | 1 | 2 // 0免费  1.按时长  2.按流量
// const statusTexts = {
//     0: '未订购',
//     1: '生效中',
//     2: '已到期',
//     3: '无权限', // 无权限
//     4: '未绑定', // 未绑定
// };
function DetailButtons({shouldBind = true}) {
    const [isPending, startTransition] = useTransition();
    const [customButtons, setCustomButtons] = useState([])
    const dispatch = useDispatch()
    const payModalData = useSelect(selectPayModal)
    const {
        isLoggedIn,
        showTrialButton,
        showBuyButton,
        showRenewableButton,
        showAdditionalPurchaseButton,
        hasOrder,
        button_key,
        currentProduct,
        currentApp,
        isIntegralProduct,
        product_key,
        app_key,
        loading,
        initialState,
        productNotOrder,
    } = useButtonStatus()
    const currentName = currentApp ? currentApp?.name : currentProduct?.product?.name
    useLayoutEffect(() => {
        startTransition(() => {
            if (currentProduct) {
                dispatch(setPayModalCurrentProduct(currentProduct))
            }
            if (currentApp) {
                dispatch(setPayModalAppId(currentApp.id))
            }
            if (initialState) {
                dispatch(setRecordModalInitialState(initialState))
            }
        })
        if (!isLoggedIn || !shouldBind || loading || !currentProduct) return
        startTransition(() => {
            console.error(showBuyButton, "showbuy", currentProduct)
            const isRegister = localStorage.getItem("register")
            console.error(isRegister === "1" ? "这是新用户注册！！" : "老用户")
            const editType = localStorage.getItem("editType")
            if (editType === "应用广场_注册" || !editType) return; // 点击注册按钮的情况交给注册组件处理
            const suffix = isRegister === "1" ? "_注册" : "" // 首次注册则加上注册的后缀
            if ((editType.includes("立即订购") || editType.includes("免费试用")) && (showRenewableButton || showAdditionalPurchaseButton || hasOrder)) {
                // 已经购买的用户，点击立即订购和免费试用时不处理
                isRegister && localStorage.removeItem("register")
                editType && localStorage.removeItem("editType")
                return;
            }
            if (editType.includes("立即订购")) {
                if (showBuyButton) {
                    if (isIntegralProduct) {
                        toOrder(button_key, initialState, dispatch, 'order')
                    } else {
                        handlePay('purchase', initialState, dispatch, currentApp?.id, currentName)
                    }
                    getReserveInfo().then(() => {
                        reserve({
                            values: {
                                source: "应用广场",
                                extra: {
                                    source: "应用广场",
                                    editType: `${editType}${suffix}`
                                }
                            }
                        })
                    })

                } else {
                    toRecordInfo(`${editType}${suffix}`, initialState, dispatch,)
                }
            } else if (editType.includes("免费试用")) {
                if (showTrialButton) {
                    toTrial(button_key, initialState, dispatch, 'trial').then(value => {
                        getReserveInfo().then(() => {
                            reserve({
                                values: {
                                    source: "应用广场",
                                    extra: {
                                        source: "应用广场",
                                        editType: `${editType}${suffix}`
                                    }
                                }
                            })
                        })
                    })
                } else {
                    toRecordInfo(`${editType}${suffix}`, initialState, dispatch,)
                }
            } else {
                toRecordInfo(`${editType}${suffix}`, initialState, dispatch,)
            }
            isRegister && localStorage.removeItem("register")
            editType && localStorage.removeItem("editType")
        })
    }, [loading])
    useLayoutEffect(() => {
        const custom_buttons = document.getElementsByClassName("detail_app_hub_product_custom_button")
        if (custom_buttons.length) {
            const custom_buttons_data = []
            for (let i = 0; i < custom_buttons.length; i++) {
                const custom_button = custom_buttons[i]
                const button_type = custom_button?.dataset?.type
                const button_url = custom_button?.dataset?.url
                const button_name = custom_button?.dataset.name

                custom_buttons_data.push({
                    button_type,
                    button_url,
                    button_name
                })
            }
            setCustomButtons(custom_buttons_data)
        }
        let app_hub_detail_product_order_tip
        let app_hub_detail_product_order_tip_contact
        let app_hub_detail_product_order_tip_buy
        if (shouldBind) {
            // 处理应用下面的tip
            app_hub_detail_product_order_tip = document.getElementById("app-hub-detail-product-order-tip")
            app_hub_detail_product_order_tip_contact = document.getElementById("app-hub-detail-product-order-tip-contact")
            app_hub_detail_product_order_tip_buy = document.getElementById("app-hub-detail-product-order-tip-buy")
        } else {
            app_hub_detail_product_order_tip = document.getElementById("app-hub-detail-product-order-tip-mobile")
            app_hub_detail_product_order_tip_contact = document.getElementById("app-hub-detail-product-order-tip-contact-mobile")
            app_hub_detail_product_order_tip_buy = document.getElementById("app-hub-detail-product-order-tip-buy-mobile")
        }
        if (!loading && app_hub_detail_product_order_tip && productNotOrder) {
            if (app_key) {
                app_hub_detail_product_order_tip.style.display = "flex"
                if (currentProduct?.app_instance?.support_online_order) {
                    app_hub_detail_product_order_tip_buy.style.display = "inline"
                } else {
                    app_hub_detail_product_order_tip_contact.style.display = "inline"
                }
            }
            app_hub_detail_product_order_tip_buy.addEventListener("click", () => {
                if (isIntegralProduct) {
                    toOrder(product_key, initialState, dispatch, 'order')
                } else {
                    handlePay('purchase', initialState, dispatch, "", currentName)
                }
            })
            app_hub_detail_product_order_tip_contact.addEventListener("click", () => {
                toRecordInfo(`${currentProduct?.product?.name}_联系专属销售`, initialState, dispatch)
            })
        }
    }, [loading])
    useEffect(() => {
        const product_key = currentProduct?.product?.product_key
        if (product_key && currentProduct?.app_instance?.support_online_order) {
            getEnterpriseLoginUrl({
                values: {
                    product_key,
                },
            }).then((result) => {
                dispatch(setPayModalProductUrl(result?.data?.url))
            })
        }
    }, [loading])

    useEffect(() => {
        if (!loading) {
            const callback = localStorage.getItem('callback')
            localStorage.removeItem("callback")
            if (!callback) return
            const callbacks = {
                toOrder: {
                    func: toOrder,
                    params: [[button_key], [initialState], [dispatch], 'type', 'self'],
                },
                handlePay: {
                    func: handlePay,
                    params: ['type', [initialState], [dispatch], [currentApp?.id], [currentName]],
                },
                toRecordInfo: {
                    func: toRecordInfo,
                    params: ['type', [initialState], [dispatch], 'source'],
                },
            }
            const currentCallbackParamKeys = callbacks[callback].params
            const currentCallbackParams = currentCallbackParamKeys.map(
                (currentCallbackParamKey) => {
                    if (Array.isArray(currentCallbackParamKey)) return currentCallbackParamKey[0]
                    const currentCallbackParamValue = localStorage.getItem(currentCallbackParamKey)
                    localStorage.removeItem(currentCallbackParamKey)
                    return currentCallbackParamValue
                }
            )
            callbacks[callback].func(...currentCallbackParams)
        }
    }, [loading])
    const displayedCustomButtons = customButtons.filter(customButton => {
        if (
            ((showTrialButton || showRenewableButton || showAdditionalPurchaseButton) || hasOrder) &&
            customButton.button_name === "免费试用"
        ) {
            return false;
        }

        if (
            ((showBuyButton || showRenewableButton || showAdditionalPurchaseButton) || hasOrder) &&
            customButton.button_name === "立即订购"
        ) {
            return false;
        }
        return true;
    })
    if (loading) return null
    return (
        <>
            {displayedCustomButtons.map((customButton, index) => {
                return (
                    <Button
                        type={index === 0 ? "primary" : ""}
                        onClick={() => {
                            if (!isLoggedIn) {
                                const title = document.getElementById("detail_app_hub_product_main_top_right_title")?.innerText?.trim()
                                return goLogin(ENTERPRISE_BASE_URL, `${title}_${customButton.button_name}`)
                            }
                            if (customButton.button_type === "0") {
                                let name = currentProduct?.product?.name
                                if (app_key) {
                                    name = currentApp.name
                                }
                                console.log("record", `${name}_${customButton.button_name}`)
                                toRecordInfo(`${name}_${customButton.button_name}`, initialState, dispatch,)
                            } else if (customButton.button_type === "1" && customButton.button_url) {
                                window.open(customButton.button_url, "_blank")
                            }
                        }}>
                        {customButton.button_name}
                    </Button>
                )
            })}
            {
                showTrialButton ? (
                    <Button
                        className={`xd_${button_key}_trial_btn`}
                        key={`xd_${button_key}_trial_btn`}
                        data-testid="detail-buttons-trial-btn"
                        type={!displayedCustomButtons.length ? "primary" : ""}
                        onClick={() => {
                            if (!isLoggedIn) {
                                const title = document.getElementById("detail_app_hub_product_main_top_right_title")?.innerText?.trim()
                                return goLogin(ENTERPRISE_BASE_URL, `${title}_免费试用`)
                            }
                            toTrial(button_key, initialState, dispatch, 'trial')
                        }}
                    >
                        免费试用
                    </Button>
                ) : null
            }
            {
                showBuyButton ? (
                    <Button
                        type={!displayedCustomButtons.length && !showTrialButton ? "primary" : ""}
                        className={`xd_${button_key}_order_btn`}
                        key={`xd_${button_key}_order_btn`}
                        data-testid="detail-buttons-order-btn"
                        loading={payModalData.isLoading}
                        onClick={() => {
                            if (!isLoggedIn) {
                                const title = document.getElementById("detail_app_hub_product_main_top_right_title")?.innerText?.trim()
                                return goLogin(ENTERPRISE_BASE_URL, `${title}_立即订购`)
                            }
                            if (isIntegralProduct) {
                                toOrder(button_key, initialState, dispatch, 'order')
                            } else {
                                handlePay('purchase', initialState, dispatch, currentApp?.id, currentName)
                            }
                        }}
                    >
                        立即订购
                    </Button>
                ) : null
            }
            {
                showRenewableButton ? (
                    <Button
                        type={!displayedCustomButtons.length && !showTrialButton && !showBuyButton ? "primary" : ""}
                        className={`xd_${button_key}_renew_btn`}
                        key={`xd_${button_key}_renew_btn`}
                        data-testid="detail-buttons-renew-btn"
                        loading={payModalData.isLoading}
                        onClick={() => {
                            if (isIntegralProduct) {
                                toOrder(button_key, initialState, dispatch, 'order')
                            } else {
                                handlePay('renew', initialState, dispatch, currentApp?.id, currentName)
                            }
                        }}
                    >
                        续订
                    </Button>
                ) : null
            }
            {
                showAdditionalPurchaseButton ?
                    (
                        <Button
                            type={!displayedCustomButtons.length && !showTrialButton && !showBuyButton && !showRenewableButton ? "primary" : ""}
                            className={`xd_${button_key}_repurchase_btn`}
                            key={`xd_${button_key}_repurchase_btn`}
                            data-testid="detail-buttons-repurchase-btn"
                            loading={payModalData.isLoading}
                            onClick={() => handlePay('repurchase', initialState, dispatch, currentApp?.id, currentName)}
                        >
                            增购
                        </Button>
                    ) : null
            }
        </>
    )

}

DetailButtons.displayName = "DetailButtons";

export default DetailButtons
